let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7XRy3")).then(() => parcelRequire('gu2ky'));